import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Header />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}